import { handleActions } from 'redux-actions';

import * as commonReducers from './common';
import * as actions from '../actions/request-logs';

const {
  fetch,
  remove,
} = commonReducers.operationTypes;

const fetchRequestLogsSuccessReducer = (
  state,
  {
    payload: { logs = {}, ids = [] } = {},
  },
) => ({
  ...state,
  ids,
  items: { ...state.items, ...logs },
});


export const requestLogsReducer = handleActions(
  {
    // fetch
    [actions.fetchRequestLogsRequest]: commonReducers.commonRequestReducer(fetch),
    [actions.fetchRequestLogsFailure]: commonReducers.commonRequestReducer(fetch),
    [actions.fetchRequestLogsSuccess]: fetchRequestLogsSuccessReducer,

    // delete
    [actions.removeRequestLogRequest]: commonReducers.commonRequestReducer(remove),
    [actions.removeRequestLogFailure]: commonReducers.commonFailureReducer(remove),
    [actions.removeRequestLogSuccess]: commonReducers.deleteSuccessReducer,
  },
  {
    ids: [],
  },
);



// WEBPACK FOOTER //
// ./src/redux/reducers/request-logs.js